import { render, staticRenderFns } from "./icon-shopping-bag.vue?vue&type=template&id=dc85fb4e&scoped=true&"
import script from "./icon-shopping-bag.vue?vue&type=script&lang=js&"
export * from "./icon-shopping-bag.vue?vue&type=script&lang=js&"
import style0 from "./icon-shopping-bag.vue?vue&type=style&index=0&id=dc85fb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc85fb4e",
  null
  
)

export default component.exports